import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface AccessDialogData {
  titleText?: string;
}

@Component({
  selector: 'app-access-dialog',
  templateUrl: './access-dialog.component.html',
  styleUrls: ['./access-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessDialogComponent implements OnInit {
  settings = {
    titleText: 'Confirm Action'
  };

  constructor(
    public dialogRef: MatDialogRef<AccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AccessDialogData
  ) {
    if (data) {
      this.settings = {
        ...this.settings,
        ...data
      };
    }
  }

  ngOnInit() {
  }

}
